module.exports = __webpack_public_path__ + "assets/img/juqu_content_3.3dde5e67.png";